<section class="vault-access-denied card-like" role="alert" aria-live="polite">
  <p class="vault-access-denied__title">{{ title() }}</p>
  <p class="vault-access-denied__text">{{ resolvedMessage() }}</p>
</section>
